import { Check, X } from "lucide-react";
import React from "react";
import Spacing from "../Spacing";

export default function InsuranceViewModal({
  acceptInsuranceData = [],
  viewInsurances = "",
  setViewInsurances = () => {},
}) {

  return (
    <>
      {viewInsurances && (
        <div className="docpro_modal_wrap">
          <div className="docpro_modal_overlay" ></div>
          <div className="docpro_modal">
            <button
              className="docpro_close_btn"
              onClick={() => setViewInsurances(!viewInsurances)}
            >
              <X />
            </button>
            <h2 className="docpro_fs_24 docpro_mb_0">Accepted Insurance</h2>
            <Spacing lg="20" sm="20" />
            <ul className="pb-1 mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
              {acceptInsuranceData?.map((element, index) => (
                <li key={index} className="py-1">
                  <p className='docpro_mb_0 flex items-center'><Check width={15} height={15} className="mr-2 docpro_green_color" /> {element}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
